exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-66c5e0da] .el-table__body .el-table__row.hover-row>td.el-table__cell{background-color:transparent!important}", ""]);

// exports
